import { connect } from "react-redux";
import { getCommunications, getSession, getTokenTypes } from "../selectors";
import EnterTournamentLightbox from "../components/enter-tournament-lightbox";

function select(state, props) {
  return {
    communications: getCommunications(state, props),
    session: getSession(state, props),
    tokenTypes: getTokenTypes(state, props),
  };
}

export default connect(select)(EnterTournamentLightbox);
